import { CrudQueryBuilderError } from "./CrudQueryBuilderError.js";
import { ReadBuilder } from "./ReadBuilder.js";
import { WriteBuilder } from "./WriteBuilder.js";
import { RootObjectBuilder } from "../graphQlBuilder/RootObjectBuilder.js";
import { QueryBuilder } from "../graphQlBuilder/QueryBuilder.js";
import { isEmptyObject } from "../utils/isEmptyObject.js";
import { ObjectBuilder } from "../graphQlBuilder/ObjectBuilder.js";
class CrudQueryBuilder {
  constructor(type = void 0, rootObjectBuilder = new RootObjectBuilder()) {
    this.type = type;
    this.rootObjectBuilder = rootObjectBuilder;
  }
  fragment(name, typeName, query) {
    const readBuilder = ReadBuilder.instantiateFromFactory(query);
    const objectBuilder = readBuilder.objectBuilder.name(typeName);
    return new CrudQueryBuilder(this.type, this.rootObjectBuilder.fragment(name, objectBuilder));
  }
  list(name, query, alias) {
    if (this.type === "mutation") {
      throw new CrudQueryBuilderError("Cannot combine queries and mutations");
    }
    name = `list${name}`;
    query = ReadBuilder.instantiateFromFactory(query);
    const [objectName, objectBuilder] = typeof alias === "string" ? [alias, query.objectBuilder.name(name)] : [name, query.objectBuilder];
    return new CrudQueryBuilder("query", this.rootObjectBuilder.object(objectName, objectBuilder));
  }
  paginate(name, query, alias) {
    if (this.type === "mutation") {
      throw new CrudQueryBuilderError("Cannot combine queries and mutations");
    }
    name = `paginate${name}`;
    query = ReadBuilder.instantiateFromFactory(query);
    const [objectName, objectBuilder] = typeof alias === "string" ? [alias, query.objectBuilder.name(name)] : [name, query.objectBuilder];
    return new CrudQueryBuilder("query", this.rootObjectBuilder.object(objectName, objectBuilder));
  }
  get(name, query, alias) {
    if (this.type === "mutation") {
      throw new CrudQueryBuilderError("Cannot combine queries and mutations");
    }
    name = `get${name}`;
    query = ReadBuilder.instantiateFromFactory(query);
    const [objectName, objectBuilder] = typeof alias === "string" ? [alias, query.objectBuilder.name(name)] : [name, query.objectBuilder];
    return new CrudQueryBuilder("query", this.rootObjectBuilder.object(objectName, objectBuilder));
  }
  update(name, query, alias) {
    if (this.type === "query") {
      throw new CrudQueryBuilderError("Cannot combine queries and mutations");
    }
    name = `update${name}`;
    query = WriteBuilder.instantiateFromFactory(query);
    if (isEmptyObject(query.objectBuilder.args.data)) {
      return this;
    }
    const [objectName, objectBuilder] = typeof alias === "string" ? [alias, query.objectBuilder.name(name)] : [name, query.objectBuilder];
    return new CrudQueryBuilder("mutation", this.rootObjectBuilder.object(objectName, objectBuilder));
  }
  create(name, query, alias) {
    if (this.type === "query") {
      throw new CrudQueryBuilderError("Cannot combine queries and mutations");
    }
    name = `create${name}`;
    query = WriteBuilder.instantiateFromFactory(query);
    if (isEmptyObject(query.objectBuilder.args.data)) {
      return this;
    }
    const [objectName, objectBuilder] = typeof alias === "string" ? [alias, query.objectBuilder.name(name)] : [name, query.objectBuilder];
    return new CrudQueryBuilder("mutation", this.rootObjectBuilder.object(objectName, objectBuilder));
  }
  delete(name, query, alias) {
    if (this.type === "query") {
      throw new CrudQueryBuilderError("Cannot combine queries and mutations");
    }
    name = `delete${name}`;
    query = WriteBuilder.instantiateFromFactory(query);
    const [objectName, objectBuilder] = typeof alias === "string" ? [alias, query.objectBuilder.name(name)] : [name, query.objectBuilder];
    return new CrudQueryBuilder("mutation", this.rootObjectBuilder.object(objectName, objectBuilder));
  }
  inTransaction(alias = "transaction", options = {}) {
    const objectBuilder = new ObjectBuilder(
      ["ok", "errorMessage"],
      { ...this.rootObjectBuilder.objects },
      { options },
      void 0,
      void 0,
      "transaction"
    );
    return new CrudQueryBuilder(this.type, new RootObjectBuilder({ [alias]: objectBuilder }, this.rootObjectBuilder.fragmentDefinitions));
  }
  getGql() {
    const builder = new QueryBuilder();
    switch (this.type) {
      case "mutation":
        return builder.mutation(this.rootObjectBuilder);
      case "query":
        return builder.query(this.rootObjectBuilder);
      default:
        throw new CrudQueryBuilderError(`Invalid type ${this.type}`);
    }
  }
}
export {
  CrudQueryBuilder
};
//# sourceMappingURL=CrudQueryBuilder.js.map
